import { render, staticRenderFns } from "./PageLoader.vue?vue&type=template&id=5f2db850&scoped=true&"
import script from "./PageLoader.vue?vue&type=script&lang=ts&"
export * from "./PageLoader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2db850",
  null
  
)

export default component.exports